// ui/src/Forms/Loaders/components/TextInputSkeleton.js
import { Mui } from "@osu/react-ui";

function TextInputSkeleton() {
  return (
    <Mui.Box sx={{ mb: 3 }}>
      <Mui.Skeleton variant="text" width="40%" height={24} />
      <Mui.Skeleton variant="rectangular" width="100%" height={56} />
    </Mui.Box>
  );
}

export default TextInputSkeleton;
